import React from "react";

import { IFallbackProps } from "@Components/shared/ErrorBoundary";
import { hasCapabilityContext, useSearchParams } from "@Utils";
import { Alert } from "antd";
import { CloseCircleFilled } from "@ant-design/icons";
import { GroupContext } from "@Constants";

export const AssessmentsError: React.FC<IFallbackProps> = ({ error, resetErrorBoundary }) => {
  const [, setSearchParams] = useSearchParams();

  const canCreate = hasCapabilityContext("Assessment/Create", GroupContext);

  const handleClose = () => {
    resetErrorBoundary();
    setSearchParams({ tab: canCreate ? "current" : "assigned" }, { replace: true });
  };

  return (
    <Alert
      closable
      closeIcon={<CloseCircleFilled style={{ color: "#888", fontSize: "1rem" }} />}
      description={error?.message ? error.message : "There was an issue displaying these assessments."}
      message="Error"
      onClose={handleClose}
      showIcon
      type="error"
    />
  );
};
